import _ from 'underscore';

import { Messages } from '../../../../codegen/Localize';
import { IDatasourceActions } from '../../../../datasource/ServerApi/types/IDatasourceActions';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import {RefreshPropertyHelper} from '../../../../ts/helpers/RefreshPropertyHelper';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { IExtractTaskInfo } from '../../../../ts/models/IExtractTaskInfo';
import { IWorkbookActions } from '../../../../workbook/ServerApi/types/IWorkbookActions';
import { runExtractRefresh } from '../../../actions/spaces/RunExtractRefreshAction';
import { runExtractRefreshNow } from '../../../actions/spaces/RunExtractRefreshNowAction';
import { getAppStore } from '../../../AppStore';
import { SessionSiteSelectors } from '../../../selectors/SessionInfoSelectors';
import { selectSpaceInfoItem } from '../../../selectors/SpaceInfoSelectors';
import { AppState } from '../../../state/AppState';
import { hasExtractRefreshPermission, hasRunNowPermission } from '../../../utils/MixedContentHelpers';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const RunExtractRefreshEntityAction: IEntityAction<IExtractTaskInfo, IWorkbookActions | IDatasourceActions> = {
  name: EntityActionNames.TasksRunNow,
  translateName: Messages.runNow_action,
  isVisible: () => true,
  isClickable: isClickable,
  createReduxAction: runExtractRefresh
};

export const RunExtractRefreshEntityIfRefreshSSSEnabledAction: IEntityAction<IContentInfo, IWorkbookActions | IDatasourceActions> = {
  name: EntityActionNames.TasksRunNow,
  translateName: Messages.runNow_actionSSS,
  isVisible: isVisible,
  isClickable: isClickable,
  createReduxAction: (items: IContentInfo[]) => {
    return runExtractRefreshNow(items);
  }
};

function isClickable(
  availableActions: IWorkbookActions | IDatasourceActions,
  tasks: IExtractTaskInfo[] | IContentInfo[],
  state: AppState
): boolean {
  const spaceItem = selectSpaceInfoItem(state);
  const canRefresh = !availableActions || !!(availableActions && availableActions.refreshExtract);
  const hasPermissionToRefresh = hasExtractRefreshPermission(state, spaceItem, availableActions) && hasRunNowPermission(state) &&
  !RefreshPropertyHelper.isDataSourceWithLegacyBridgeSchedule(spaceItem);
  return canRefresh && hasPermissionToRefresh;
}

function isVisible(
  tasks: IExtractTaskInfo[] | IContentInfo[], state: AppState
): boolean {
  // Datasouces specifically cannot be refreshed if they belong to a workbook
  // A datasource is an embeded one iff it has a workbook field that is an object
  const anyEmbeddedDatasources = _.any(tasks, (task: IExtractTaskInfo | IContentInfo) => {
    return task.contentType === 'datasource' && 'workbook' in task && _.isObject(task.workbook);
  });
  if (anyEmbeddedDatasources) {
    return false;
  }
  return FeatureFlags.selfServiceSchedulesForRefreshEnabled && SessionSiteSelectors.isSelfServiceSchedulesForRefreshEnabled(getAppStore().getState());
}
